import styled from "styled-components";

export const MainContainer = styled.div`
  padding: 0 16px;
  p {
    /* text-align: center; */
    margin-bottom: 8px;
  }
`;
